/* NARA Tackle – Interaktionen (Varianten, Galerie, Warenkorb, Menü) */
(() => {
  'use strict';

  /* ---------- Dialoge (Mobilmenü, Rechtstexte) ---------- */
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-nara-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.naraOpen);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-nara-close]');
    const dialog = event.target.closest('dialog');
    // Schließen per Button oder Klick auf den Hintergrund
    if (dialog && (closer || event.target === dialog)) dialog.close();
  });

  /* ---------- Warenkorb-Zähler und Hinweis ---------- */
  const updateCartCount = (count) => {
    document.querySelectorAll('[data-nara-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
    document.querySelectorAll('[data-nara-cart-link]').forEach((link) => {
      link.setAttribute('aria-label', `Warenkorb, ${count} Artikel`);
    });
  };

  let toastTimer;
  const showToast = (text) => {
    const toast = document.getElementById('NaraToast');
    if (!toast) return;
    toast.querySelector('[data-nara-toast-text]').textContent = text;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 6000);
  };

  /* ---------- Warenkorb: Menge mit − / + ändern ---------- */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-nara-cart-qty]');
    if (!button) return;
    const input = button.closest('.nara-qty')?.querySelector('input');
    if (!input || !input.form) return;
    const next = Math.max(0, (parseInt(input.value, 10) || 0) + Number(button.dataset.naraCartQty));
    input.value = next;
    // Alle Buttons sperren, damit kein Doppelklick zwei Anfragen auslöst
    input.form.querySelectorAll('[data-nara-cart-qty]').forEach((b) => { b.disabled = true; });
    input.form.submit();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-nara-toast-close]')) {
      document.getElementById('NaraToast')?.classList.remove('is-visible');
    }
  });

  /* ---------- Produktseite ---------- */
  class NaraProduct {
    constructor(root) {
      this.root = root;
      this.section = root.closest('section');
      this.form = root.querySelector('[data-nara-product-form]');
      this.variants = JSON.parse(this.section.querySelector('[data-nara-variants]')?.textContent || '[]');
      this.lowStock = Number(root.dataset.lowStock || 0);
      this.fieldsets = [...root.querySelectorAll('[data-nara-option]')];

      this.fieldsets.forEach((fieldset) => {
        fieldset.addEventListener('change', () => this.onOptionChange());
      });

      root.querySelectorAll('.nara-thumb').forEach((thumb) => {
        thumb.addEventListener('click', () => this.showMedia(thumb.dataset.mediaId));
      });

      root.querySelectorAll('[data-nara-qty]').forEach((button) => {
        button.addEventListener('click', () => this.changeQty(Number(button.dataset.naraQty)));
      });

      this.form?.addEventListener('submit', (event) => this.onSubmit(event));
      this.initGiftRecipient();
      this.initStickyBuy();

      this.update(this.currentVariant(), false);
    }

    /* Handy: Kauf-Knopf am unteren Rand, sobald der normale Knopf nach oben weggescrollt ist */
    initStickyBuy() {
      this.sticky = this.root.querySelector('[data-nara-sticky]');
      const mainButton = this.root.querySelector('[data-nara-add]');
      if (!this.sticky || !mainButton || !('IntersectionObserver' in window)) return;

      this.sticky.querySelector('[data-nara-sticky-add]').addEventListener('click', () => {
        this.form.requestSubmit();
      });

      let passedButton = false;
      let footerVisible = false;
      const sync = () => {
        this.sticky.hidden = !passedButton || footerVisible;
      };
      new IntersectionObserver(([entry]) => {
        passedButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sync();
      }).observe(mainButton);
      const footer = document.querySelector('.nara-footer');
      if (footer) {
        new IntersectionObserver(([entry]) => {
          footerVisible = entry.isIntersecting;
          sync();
        }).observe(footer);
      }
    }

    updateStickyBuy(variant) {
      if (!this.sticky) return;
      const label = (value) => (value.startsWith('#') ? `PE ${value.slice(1).replace('.', ',')}` : value);
      this.sticky.querySelector('[data-nara-sticky-variant]').textContent = variant.options.map(label).join(' · ');
      this.sticky.querySelector('[data-nara-sticky-price]').textContent = variant.price;
      const button = this.sticky.querySelector('[data-nara-sticky-add]');
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
    }

    selectedOptions() {
      return this.fieldsets.map((fieldset) => fieldset.querySelector('input:checked')?.value);
    }

    currentVariant() {
      const selected = this.selectedOptions();
      if (!selected.length) return this.variants[0];
      return this.variants.find((variant) => variant.options.every((value, i) => value === selected[i]));
    }

    onOptionChange() {
      let variant = this.currentVariant();
      // Kombination gibt es nicht: nächstbeste Variante mit der zuletzt gewählten Option nehmen
      if (!variant) {
        const selected = this.selectedOptions();
        variant = this.variants.find((v) => v.options[0] === selected[0]) || this.variants[0];
      }
      this.update(variant, true);
    }

    update(variant, userAction) {
      if (!variant) return;
      const $ = (selector) => this.root.querySelector(selector);

      this.form.querySelector('[data-nara-variant-id]').value = variant.id;

      // Optionen synchron halten und nicht verfügbare Kombinationen markieren
      this.fieldsets.forEach((fieldset, index) => {
        fieldset.querySelectorAll('input').forEach((input) => {
          input.checked = input.value === variant.options[index];
          const candidate = this.variants.find((v) =>
            v.options.every((value, i) => (i === index ? value === input.value : value === variant.options[i]))
          );
          input.classList.toggle('is-unavailable', !candidate || !candidate.available);
        });

        const label = fieldset.querySelector('[data-nara-option-label]');
        if (!label) return;
        if (fieldset.dataset.optionName === 'Stärke' && variant.durchmesser) {
          label.textContent = `${variant.durchmesser} · ${variant.tragkraft} Tragkraft`;
        } else {
          label.textContent = variant.options[index];
        }

        const specCell = this.root.querySelector(`[data-nara-spec-option="${index}"]`);
        if (specCell) specCell.textContent = variant.options[index];
      });

      // Preis
      $('[data-nara-price-current]').textContent = variant.price;
      const compare = $('[data-nara-price-compare]');
      compare.hidden = !variant.compare;
      compare.textContent = variant.compare || '';
      $('[data-nara-price-unit]').textContent = variant.unit ? `Grundpreis: ${variant.unit}` : '';

      // Technische Daten der Variante
      const diameter = $('[data-nara-spec="durchmesser"]');
      if (diameter && variant.durchmesser) diameter.textContent = variant.durchmesser;
      const strength = $('[data-nara-spec="tragkraft"]');
      if (strength && variant.tragkraft) strength.textContent = variant.tragkraft;
      const content = $('[data-nara-spec="inhalt"]');
      if (content && variant.inhalt) content.textContent = variant.inhalt;
      const sku = $('[data-nara-spec="sku"]');
      if (sku && variant.sku) sku.textContent = variant.sku;

      // Verfügbarkeit
      const button = $('[data-nara-add]');
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      this.updateStickyBuy(variant);

      const stock = $('[data-nara-stock]');
      stock.classList.remove('nara-stock--low');
      if (!variant.available) {
        stock.textContent = 'Diese Variante ist leider ausverkauft.';
      } else if (variant.stock !== null && this.lowStock > 0 && variant.stock <= this.lowStock) {
        stock.textContent = `Nur noch ${variant.stock} auf Lager`;
        stock.classList.add('nara-stock--low');
      } else if (this.root.hasAttribute('data-nara-gift')) {
        stock.textContent = 'Sofort verfügbar · per E-Mail';
      } else {
        stock.textContent = 'Auf Lager · Versandfertig';
      }

      if (variant.media) this.showMedia(String(variant.media));

      // Stärken-Tabelle hervorheben
      const table = document.querySelector('[data-nara-strength-table]');
      if (table) {
        const position = Number(table.dataset.optionPosition);
        table.querySelectorAll('tbody tr').forEach((row) => {
          row.classList.toggle('is-selected', row.dataset.value === variant.options[position]);
        });
      }

      if (userAction) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    showMedia(mediaId) {
      this.root.querySelectorAll('.nara-gallery__main img').forEach((img) => {
        img.classList.toggle('is-active', img.dataset.mediaId === mediaId);
      });
      this.root.querySelectorAll('.nara-thumb').forEach((thumb) => {
        if (thumb.dataset.mediaId === mediaId) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }

    /* Gutschein: Empfängerfelder nur mitschicken, wenn der Haken gesetzt ist */
    initGiftRecipient() {
      const box = this.root.querySelector('[data-nara-gift-recipient]');
      if (!box) return;
      const toggle = box.querySelector('[data-nara-gift-toggle]');
      const fields = box.querySelector('[data-nara-gift-fields]');
      const date = box.querySelector('[data-nara-gift-date]');
      const offset = box.querySelector('[data-nara-gift-offset]');
      const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      const today = new Date();
      if (date) {
        date.min = toIso(today);
        date.max = toIso(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 90));
      }
      if (offset) offset.value = String(today.getTimezoneOffset());
      const sync = () => {
        const on = toggle.checked;
        fields.hidden = !on;
        fields.querySelectorAll('input, textarea').forEach((input) => {
          input.disabled = !on;
        });
      };
      toggle.addEventListener('change', sync);
      sync();
    }

    giftError() {
      const box = this.root.querySelector('[data-nara-gift-recipient]');
      if (!box?.querySelector('[data-nara-gift-toggle]')?.checked) return '';
      const email = box.querySelector('[data-nara-gift-email]');
      if (!email.value.trim() || !email.checkValidity()) {
        email.focus();
        return 'Bitte gib eine gültige E-Mail-Adresse für den Beschenkten an.';
      }
      const date = box.querySelector('[data-nara-gift-date]');
      if (date && date.value && ((date.min && date.value < date.min) || (date.max && date.value > date.max))) {
        date.focus();
        return 'Das Versanddatum muss zwischen heute und in 90 Tagen liegen.';
      }
      return '';
    }

    changeQty(delta) {
      const input = this.root.querySelector('[data-nara-qty-input]');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
    }

    async onSubmit(event) {
      event.preventDefault();
      const button = this.root.querySelector('[data-nara-add]');
      const error = this.root.querySelector('[data-nara-error]');
      error.hidden = true;
      const giftError = this.giftError();
      if (giftError) {
        error.textContent = giftError;
        error.hidden = false;
        return;
      }
      button.setAttribute('aria-disabled', 'true');

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Das hat leider nicht geklappt.');

        const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
        updateCartCount(cart.item_count);

        const variantText = data.variant_title && data.variant_title !== 'Default Title' ? ` (${data.variant_title})` : '';
        showToast(`${data.quantity} × ${data.product_title}${variantText} liegt im Warenkorb.`);
      } catch (err) {
        error.textContent = err.message;
        error.hidden = false;
      } finally {
        button.removeAttribute('aria-disabled');
      }
    }
  }

  /* ---------- Startseite: Logo beim Scrollen verkleinern ----------
     Aktuelle Browser erledigen das per CSS (Scroll-driven Animations).
     Dieses Skript ist nur der Ersatz für ältere Browser. */
  const initHeroScroll = () => {
    const hero = document.querySelector('[data-nara-hero-scroll]');
    if (!hero || hero.naraScroll) return;
    if (window.CSS && CSS.supports('animation-timeline: scroll()')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    hero.naraScroll = true;

    const logo = hero.querySelector('.nara-hero__logo');
    const texts = hero.querySelectorAll('.nara-hero__text, .nara-hero__actions, .nara-hero__scroll');
    const headerLogo = document.querySelector('.nara-header .nara-header__logo');
    const clamp = (value) => Math.min(1, Math.max(0, value));

    let ticking = false;
    const update = () => {
      ticking = false;
      // 0 = ganz oben, 1 = eine Bildschirmhöhe weit gescrollt
      const p = clamp(window.scrollY / window.innerHeight);
      if (logo) {
        logo.style.translate = `0 ${(p * 22).toFixed(2)}vh`;
        logo.style.scale = (1 - p * 0.5).toFixed(3);
        logo.style.opacity = clamp(1 - p * 1.6).toFixed(3);
      }
      const textOpacity = clamp(1 - p * 3.2).toFixed(3);
      texts.forEach((el) => { el.style.opacity = textOpacity; });
      if (headerLogo) headerLogo.style.opacity = clamp((p - 0.45) * 3.3).toFixed(3);
    };
    const onScroll = () => {
      // Theme-Editor hat die Sektion ersetzt: alten Listener entfernen
      if (!hero.isConnected) {
        window.removeEventListener('scroll', onScroll);
        return;
      }
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };

    hero.classList.add('is-js-scroll');
    document.documentElement.classList.add('is-js-scroll');
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  const init = () => {
    document.querySelectorAll('[data-nara-product]').forEach((root) => {
      if (!root.naraProduct) root.naraProduct = new NaraProduct(root);
    });
    initHeroScroll();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme-Editor: Sektionen neu initialisieren
  document.addEventListener('shopify:section:load', init);
})();
